import { createSlice } from '@reduxjs/toolkit';
import { addDistributionManagement } from './hyperwolf/inventoryDistribution';

const initialState = {
  isDistributing: false,
  error: null,
};

const distributionSlice = createSlice({
  name: 'distribution',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addDistributionManagement.pending, (state) => {
        state.isDistributing = true;
      })
      .addCase(addDistributionManagement.fulfilled, (state) => {
        state.isDistributing = false;
      })
      .addCase(addDistributionManagement.rejected, (state) => {
        state.isDistributing = false;
      });
  },
});

export default distributionSlice.reducer;
